<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/arrow_left.png" alt="" class="logo" @click="back()">
            <span class="title">{{ $t("message.guest") }}</span>
            <img src="../img/m/m_menu.png" alt="" class="menu" @click="showNavBar()">  
        </div>
        <div class="content">
            <div class="scrollCon">
            <div class="list" v-if="guestData&&$i18n.locale=='cn'">
                <div class="avatarCon">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+guestData.avatar" alt="">
                    <div class="guestInfo">
                        <div>{{guestData.realname}}</div>
                        <div class="guestTitle">{{guestData.title}}</div>
                    </div>
                </div>
                <div class="videoCon" v-for="(newsItem, index) in guestData.videos" :key="index">
                    <div class="videoTitle">{{newsItem.title}}</div>
                    <video :src="'http://conference2019.hanban.org'+'/upload/'+newsItem.source" controls></video>
                    <div class="videoDes">{{newsItem.description}}</div>
                </div>
                <div class="guestProfile">
                    {{guestData.profile}}
                </div>

                
            </div>
            <div class="list" v-if="guestData&&$i18n.locale=='en'">
                <div class="avatarCon">
                    <img :src="'http://conference2019.hanban.org'+'/upload/'+guestData.avatar" alt="">
                    <div class="guestInfo">
                        <div>{{guestData.realname_en}}</div>
                        <div class="guestTitle">{{guestData.title_en}}</div>
                    </div>
                </div>
                <div class="videoCon" v-for="(newsItem, index) in guestData.videos" :key="index">
                    <div class="videoTitle">{{newsItem.title}}</div>
                    <video :src="'http://conference2019.hanban.org'+'/upload/'+newsItem.source" controls></video>
                    <div class="videoDes">{{newsItem.description}}</div>
                </div>
                <div class="guestProfile">
                    {{guestData.profile_en}}
                </div>
                
            </div>
            </div>
                
        </div>
        <mt-popup
        v-model="navbarShow" 
        position="right" class="secondPage">
            <m_navbar @close="close"/>
        </mt-popup>
    </div>
</template>

<script>
import m_navbar from './m_navbar'
export default {
    name: 'm_guestdetail',
    components: {
        m_navbar
    },
    data: function () {
        return {
            navbarShow: false,
            newsDetail: [],
            from: '',
            guest_id:null,
            guestData: {}
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
        back () {
            this.$router.go(-1)
            // if(this.from == 'm_topicdetail'){
            //     this.$router.push('/m_page/m_detailpage/m_topicdetail')
            // }
        },
        showNavBar () {
            this.navbarShow = true
            },
        close () {
            this.navbarShow = false
        },
        getNewsList(id) {
        this.$utils
            .get("guest/api/showGuest", {
                lang: this.language,
                id: id,
                with_video: 1
            })
            .then(res => {
            this.guestData = res.data.data
            });
        },
    },
    watch: {
      // 监听切换语言
      language (newval, old) {
          this.getNewsList(this.guest_id)
      }
    },
    mounted() {
        if(this.$route.query.from == 'm_topicdetail'){
            this.from = 'm_topicdetail'
        }
        this.guest_id = this.$route.query.id
        this.getNewsList(this.guest_id)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 0.22rem;
            margin: 0 0.3rem 0 0.54rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        width: 100%;
        background-color: #fff;
        height: calc(100% - 1.4rem);
        overflow: hidden;
        .scrollCon {
            height: 100%;
            
            overflow-y: auto;
            .list {
                .avatarCon {
                    padding: 0.26rem 0.3rem;
                    box-sizing: border-box;
                    img {
                        width: 1.82rem;
                        height: 1.82rem;
                        border-radius: 50%;
                    }
                    .guestInfo {
                        display: inline-block;
                        vertical-align: top;
                        width: calc(100% - 2.42rem);
                        padding: 0.4rem 0 0 0.4rem;
                        word-break: break-all;
                        box-sizing: border-box;
                        div:first-child {
                            font-size: 0.41rem;
                            color: #282828;
                            font-weight: bold;
                        }
                        div:last-child {
                            font-size: 0.24rem;
                            color: #999;
                            margin-top: 0.2rem;
                            line-height: 1.2;
                            word-break: break-all;
                        }
                    }
                }
                .guestProfile {
                    font-size: 0.24rem;
                    color: #282828;
                    word-break: break-all;
                    padding: 0.3rem 0.59rem;
                    line-height: 1.4;
                }
                .videoCon {
                    video {
                        width: 100%;
                    }
                }
            }

        }



    }
}
.secondPage {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-image: url(../img/m/m_bg.png);
    background-size: cover;
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
